const API_BASE = (process.env.REACT_APP_BCS_API_BASE || "https://admin.ooobcs.org").replace(/\/$/, "");

async function post(path, body, token) {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), 45000);
  try {
    const res = await fetch(`${API_BASE}${path}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify(body),
      signal: controller.signal,
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
      const err = new Error(data.error || `Request failed (${res.status})`);
      err.status = res.status;
      throw err;
    }
    return data;
  } finally {
    clearTimeout(timer);
  }
}

/**
 * Asks the server whether this person is already registered (email, phone or face).
 * `descriptors` carries extra faces to compare, e.g. the passport photo alongside the live scan.
 * Resolves to { ok, duplicate: { field, message, emailHint } | null, photo: { ok, reason } | null }.
 */
export function checkRegistration({ stage, email, phone_number, first_name, last_name, photo, descriptor, descriptors }) {
  return post("/api/public/registration/check", {
    stage,
    email,
    phone_number,
    first_name,
    last_name,
    photo,
    descriptor,
    descriptors,
  });
}

export function indexMemberFace(idToken, descriptor) {
  return post("/api/public/registration/index-face", { descriptor }, idToken);
}
